// extracted by mini-css-extract-plugin
export var assigneeBadge = "_kf-0";
export var assigneeDetails = "_kf-1";
export var assigneeInfo = "_kf-2";
export var dropdownContainer = "_kf-4";
export var dropdownImage = "_kf-5";
export var editAssigneeInfo = "_kf-3";
export var editAssigneeModalContainer = "_kf-6";
export var hidden = "_kf-8";
export var input = "_kf-7";